import React from 'react';
import Link from 'next/link';
import CommonSkeleton from '../../components/common/commonskeleton.jsx';
import EmptyCart from "../Checkout/emptycart";
import moment from 'moment';
import Image from 'next/image';
import ProductImage from '../common/ProductImage.jsx';
import { checkProductType } from "../../lib/utils/checkProductType";

const Step1 = ({orders_data, updatecartquantity, removeProduct, loader, savelaterproduct, showData, laterProducts, addprodtocart, checkifproductsplitable, isSplittable}) => {
    const productsAvailable = orders_data?.order?.orderLines?.filter(line => line.booking===0);
    const bookingProducts = orders_data?.order?.orderLines?.filter(line => line.booking===1);

    const countDifferentDates = (orderProducts = []) => {
        const tableObj = {}
        orderProducts.forEach(el => {
            tableObj[el.fechaEdicion] = null;           
        });
        const tableUniqueIDs = Object.keys(tableObj).length;

        return tableUniqueIDs        
    };

    const differentBookingDates =  countDifferentDates(bookingProducts);

    return (
        <>
            <div className="clearfix"></div>
            <form>
            {showData == 'availableproduct' ?
            <>
                {orders_data && productsAvailable?.length > 0 ?
                <table className="table-form-3 avail-products" width="100%" cellSpacing="0" cellPadding="0">
                    <tbody>
                        <tr>
                            <th colSpan="2">PRODUCTOS DISPONIBLES</th>
                            <th>PRECIO UNIDAD</th>
                            <th>CANTIDAD</th>
                            <th>PRECIO TOTAL</th>
                        </tr>
                        {productsAvailable.map((val, i) => {                        
                            return( <tr key={`available${i}`}>
                                <td colSpan="0" className="img-wrapper">    
                                    <ProductImage slug={`/${checkProductType(val.productTypeId)}/${val.slug}`} imageName={val?.productImageUrl} imgTag={true}></ProductImage>                                    
                                </td>
                                <td className="tohidetd"><img className="cross1" src="assets/images/close_black_24dp.png" onClick={() => removeProduct(val?.productid, 1)}/></td>
                                <td>
                                    <p>{val?.productName}</p>
                                    <a href="#" onClick={() => savelaterproduct(val?.productid, 0)}>Guardar para más tarde</a>
                                </td>
                                <td>{val?.unitDiscountAmount !== "" && val?.unitDiscountAmount !== "0,00" ? <><span>{val?.price}€</span><br/> <label className="blue-text">{val?.unitDiscountAmount}€</label></>: <><p className="text-left">{val?.price}€</p></>}</td>
                                <td className="tohidetd"><small className="total hide">Precio unidad: {val?.price}€</small></td>
                                <td><Link className="left-arrow" href="#" passHref={true}><i className="material-icons quan_arrow_back" onClick={() => updatecartquantity(val?.productid, 'subtract', val?.quantity)}>arrow_back</i></Link><input className="field_1" value={val?.quantity} type="text" readOnly /><Link className="right-arrow" href="#"><i className="material-icons quan_arrow_frwd" onClick={() => updatecartquantity(val?.productid, 'add', val?.quantity)}>arrow_forward</i></Link></td>
                                <td>
                                {
                                    !loader ?
                                    <>
                                    <p><small className="total hide">Precio total: </small>{val?.totalLine}€ <Link href="#" passHref={true}><img className="cross" src="assets/images/close_black_24dp.png" onClick={() => removeProduct(val?.productid)}/></Link></p>
                                    </>
                                    :
                                    <CommonSkeleton pagetoshow='buyingprice' />
                                    }
                                </td>
                            </tr>)
                        })}
                        <tr>
                            <td colSpan="4">
                                <div className="subtotal">
                                    <p>Subtotal</p>
                                    <p>I.V.A.</p>
                                    <p><b>Total</b></p>
                                </div>
                            </td>
                            <td>
                            {!loader ?
                            <>
                                <p className="totalamt">{orders_data?.order?.totalAvailables?.orderWOTax}€</p>
                                <p className="totalamt">{orders_data?.order?.totalAvailables?.taxAmount}€</p>
                                <p className="totalamt"><b>{orders_data?.order?.totalAvailables?.orderTotal}€</b></p>
                            </>
                            :
                            <CommonSkeleton pagetoshow='buyingtotalprice' />
                            }
                            </td>
                        </tr>
                    </tbody>
                </table>
                :
                <EmptyCart cartType='available'/>
                }
            </>
            :
            showData == 'bookingproduct' ?
            <>
                {orders_data && bookingProducts?.length > 0 &&
                    <>
                        <table className="table-form-3 reserveproducts" width="100%" cellSpacing="0" cellPadding="0">
                            <tbody>
                                <tr>
                                    <th colSpan="2">PRODUCTOs reservados</th>
                                    <th>PRECIO UNIDAD</th>
                                    <th>CANTIDAD</th>
                                    <th>PRECIO TOTAL</th>
                                </tr>
                                {bookingProducts.map((val, i) => {
                                return( 
                                    <tr key={`booking${i}`}>
                                        <td colSpan="0" className="img-wrapper">
                                            <ProductImage slug={`/${checkProductType(val.productTypeId)}/${val.slug}`} imageName={val?.productImageUrl} imgTag={true}></ProductImage>                                            
                                        </td>
                                        <td className="tohidetd"><img className="cross1" src="assets/images/close_black_24dp.png" onClick={() => removeProduct(val?.productid, 1)}/></td>
                                        <td>
                                            <p>{val?.productName}</p>
                                            <label className="blue" href="#">Disponible a partir del {moment(val?.fechaEdicion).format('DD/MM/YYYY')}</label>
                                        </td>
                                        <td>{val?.unitDiscountAmount !== "" && val?.unitDiscountAmount !== "0,00" ? <><span>{val?.price}€</span><br/> <label className="blue-text">{val?.unitDiscountAmount}€</label></>: <><p className="text-left">{val?.price}€</p></>}</td>
                                        <td className="tohidetd"><small className="total hide">Precio unidad: {val?.price}€</small></td>
                                        <td><Link className="left-arrow" href="#" passHref={true}><i className="material-icons quan_arrow_back" onClick={() => updatecartquantity(val?.productid, 'subtract', val?.quantity)}>arrow_back</i></Link><input readOnly className="field_1" value={val?.quantity}  type="text" /><Link className="right-arrow" href="#"><i className="material-icons quan_arrow_frwd" onClick={() => updatecartquantity(val?.productid, 'add', val?.quantity)}>arrow_forward</i></Link></td>
                                        <td>
                                            {!loader ?
                                            <>
                                                <p><small className="total hide">Precio total: </small>{val?.totalLine}€ <Link href="#" passHref={true}><img className="cross" src="assets/images/close_black_24dp.png" onClick={() => removeProduct(val?.productid)}/></Link></p>
                                            </>
                                            :
                                                <CommonSkeleton pagetoshow='buyingprice' />
                                            }
                                        </td>
                                    </tr>)
                                })}
                                <tr>
                                    <td colSpan="4">
                                        <div className="subtotal">
                                        <p>Subtotal</p>
                                        <p>I.V.A.</p>
                                        <p><b>Total</b></p>
                                        </div>
                                    </td>
                                    <td>
                                    {!loader ?
                                        <>
                                            <p className="totalamt">{orders_data?.order?.totalBookings?.orderWOTax}€</p>
                                            <p className="totalamt">{orders_data?.order?.totalBookings?.taxAmount}€</p>
                                            <p className="totalamt"><b>{orders_data?.order?.totalBookings?.orderTotal}€</b></p>
                                        </>
                                        :
                                        <CommonSkeleton pagetoshow='buyingtotalprice' />
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {orders_data && (productsAvailable?.length > 0 || differentBookingDates>1) &&
                            <div className="info-select">
                                <h2>Algunos de tus productos aún no están disponibles. Selecciona la opción de envío que prefieras:</h2>
                                <form>
                                    <input type="radio" id="html" name="fav_language" value="HTML" checked={orders_data?.order?.isSplittable == 0 ? true : false} onChange={() => checkifproductsplitable(0)}/>
                                    <label htmlFor="html">Envíame todos los pedidos juntos cuando todos estén disponibles.</label>
                                    <br/>
                                    <input type="radio" id="css" name="fav_language" value="CSS" onChange={() => checkifproductsplitable(1)} checked={orders_data?.order?.isSplittable === 1 ? true : false}/>
                                    <label htmlFor="css">Envíame cada pedido en cuanto esté disponible.</label>
                                    <br/>
                                    {/*isSplittable === 0  ? <p><img src="/assets/images/bell.png"/>Alguno de tus pedidos no cumple no el monto mínimo de 12€ para hacer un envío.</p> : ''*/}
                                </form>
                            </div>
                        }
                    </>      
                }
            </>
            :
            <>
                {laterProducts?.length != 0 ?
                <>
                    <table className="table-form-3 laterproducts" width="100%" cellSpacing="0" cellPadding="0">
                        <tbody>
                            <tr>
                                <th colSpan="2">PRODUCTOS GUARDADOS PARA MÁS TARDE</th>
                                <th>PRECIO UNIDAD</th>
                                <th>CANTIDAD</th>
                                <th>PRECIO TOTAL</th>
                            </tr>
                            {laterProducts?.products?.map((val, i) => {
                                return( 
                                <tr key={`saveForLater${i}`}>
                                    <td colSpan="0" className='img-wrapper'>
                                        <ProductImage slug={`/${checkProductType(val.productTypeId)}/${val.slug}`} imageName={val?.image} imgTag={true}></ProductImage>                                                                                    
                                    </td>
                                    <td className="tohidetd"><img className="cross1" src="assets/images/close_black_24dp.png" onClick={() => savelaterproduct(val?.id, 1)}/></td>
                                    <td>
                                        <p>{val?.title}</p>
                                        <a onClick={() => addprodtocart(val?.id)}>Añadir al carrito</a>
                                    </td>
                                    <td>{val?.unitDiscountAmount !== "" && val?.unitDiscountAmount !== "0,00" ? <><span>{val?.price}€</span><br/> <label className="blue-text">{val?.unitDiscountAmount}€</label></>: <><p className="text-left">{val?.price}€</p></>}</td>
                                    <td className="tohidetd"><small className="total hide">Precio unidad: {val?.price}€</small></td>
                                    <td><input className="field_1" value="1" readOnly  type="text" /></td>
                                    <td>
                                    {!loader ?
                                    <>
                                        <p><small className="total hide">Precio total: </small>{val?.totalLine}€ <img className="cross" src="assets/images/close_black_24dp.png" onClick={() => savelaterproduct(val?.id, 1)}/></p>
                                    </>
                                    :
                                    <CommonSkeleton pagetoshow='buyingprice' />
                                    }
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                    <div className="laterprod-blue-div">
                        <p className="mb-0">
                            <b>NOTA</b>
                            <br/>
                            Los productos guardados para después no son todavía pedidos, es decir, no se reservan en la tienda de ECC. Puede suceder que cuando decidas comprarlos ya no estén en stock.
                        </p>
                    </div>
                </>
                : 
                <EmptyCart cartType='laterproducts'/>
                }
            </>
            }
            </form>
        </>
    )
}

export default Step1;
